<p class="ln-own">{{ notice.ownership }}</p>
<p class="ln-p">{{ notice.policiesIntro }}</p>

<!-- one row per required policy; tap to read it -->
<div class="ln-list">
  <div class="ln-item" *ngFor="let pol of policies" [class.on]="openKey() === pol.key">
    <button type="button" class="ln-item-head" (click)="toggle(pol.key)"
            [attr.aria-expanded]="openKey() === pol.key">
      <span class="ln-item-txt">
        <span class="ln-item-title">{{ pol.title }}</span>
        <span class="ln-item-sub">{{ pol.sub }}</span>
      </span>
      <svg class="ln-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M6 9l6 6 6-6"/></svg>
    </button>
    <div class="ln-item-body" *ngIf="openKey() === pol.key">
      <p class="ln-p" *ngFor="let p of pol.body">{{ p }}</p>
    </div>
  </div>
</div>

<p class="ln-p">{{ notice.policiesTail }}</p>

<!-- company block: the registered name and how to reach us -->
<div class="ln-card">
  <div class="ln-card-h">{{ company.legalName }}</div>
  <div class="ln-card-l" *ngIf="company.ssm">SSM {{ company.ssm }}</div>
  <div class="ln-card-l" *ngFor="let l of company.addressLines">{{ l }}</div>
  <div class="ln-card-links">
    <a [href]="'mailto:' + company.email">{{ company.email }}</a>
    <a [href]="'tel:+' + company.phoneDigits">{{ company.phone }}</a>
  </div>
</div>

<p class="ln-note">{{ notice.note }}</p>
